// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Nav from "../main/nav";
// import Footer from "../main/footer";
// import DateRange from "../main/DateRange";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { formatToDateTime } from "../main/formatToDateTime";
// import ImportHeader from "../main/ImportHeader";
// export default function ExportRevenue() {
//   const [Data, setData] = useState([]);
//   const [start, setStart] = useState(false);
//   const [end, setEnd] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const GetData = async (page = 1) => {
//     setLoading(true);
//     try {
//       let url = `https://ctas.live/backend/api/get/ImportRevenue?start=${start}&end=${end}`;
//       const response = await axios.get(url);
//       if (response?.data?.status === "success") {
//         const lat_data = response.data.data;
//         let result;
//         if (
//           lat_data["env:Body"]["ImportReportWriteOutput"][
//             "tns:ImportReportWriteOutputColl"
//           ]
//         ) {
//           result =
//             lat_data["env:Body"]["ImportReportWriteOutput"][
//               "tns:ImportReportWriteOutputColl"
//             ];
//         } else {
//           result = [];
//         }
//         setData(result);
//       } else {
//         Swal.fire({
//           icon: "warning",
//           title: "Oops!",
//           text: "Something Went Wrong.",
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Fetch Error!",
//         text: error.message || "Something went wrong while fetching data.",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleFromSubmit = (e) => {
//     e.preventDefault();
//     if (start && end) {
//       GetData();
//     }
//   };

//   return (
//     <>
//     {loading && (
//         <div
//           className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
//           style={{ zIndex: 9999 }}
//         >
//           <div className="sk-chase sk-primary display-1">
//             <div className="sk-chase-dot" />
//             <div className="sk-chase-dot" />
//             <div className="sk-chase-dot" />
//             <div className="sk-chase-dot" />
//             <div className="sk-chase-dot" />
//             <div className="sk-chase-dot" />
//           </div>
//         </div>
//       )}
//       <div className="layout-wrapper layout-content-navbar">
//         <div className="layout-container">
//           <ImportHeader />
//           <div className="layout-page">
//             <Nav />
//             <div className="content-wrapper">
//               <div className="container-xxl flex-grow-1 container-p-y">
//                 <div className="row justify-content-between">
//                   <div className="card  my-3">
//                     <div className="card-body">
//                       <h4 className="text-primary">Import Revenue</h4>
//                       <form
//                         className="needs-validation"
//                         noValidate=""
//                         onSubmit={handleFromSubmit}
//                       >
//                         <div className="row">
//                           <div className="col-md-4">
//                             <div className="form-floating form-floating-outline mb-6">
//                               <input
//                                 type="datetime-local"
//                                 name="start_date"
//                                 className="form-control"
//                                 placeholder="Start Date & Time"
//                                 value={start}
//                                 onChange={(e) => setStart(e.target.value)}
//                               />
//                               <label className="form-label">
//                                 Start Date & Time
//                               </label>
//                             </div>
//                           </div>

//                           <div className="col-md-4">
//                             <div className="form-floating form-floating-outline mb-6">
//                               <input
//                                 type="datetime-local"
//                                 name="end_date"
//                                 className="form-control"
//                                 placeholder="End Date & Time"
//                                 value={end}
//                                 onChange={(e) => setEnd(e.target.value)}
//                               />
//                               <label className="form-label">
//                                 End Date & Time
//                               </label>
//                             </div>
//                           </div>

//                           <div className="col-md-2">
//                             <button
//                               type="submit"
//                               className="btn btn-label-primary waves-effect waves-light me-1"
//                             >
//                               <i className="ri-arrow-right-line ri-20px" />
//                             </button>
//                             <button
//                               type="button"
//                               className="btn btn-label-primary waves-effect waves-light me-1"
//                               onClick={() => window.location.reload()}
//                             >
//                               <i className="ri-restart-line ri-20px" />
//                             </button>
//                           </div>
//                         </div>
//                       </form>
//                     </div>
//                   </div>
//                   <div className="card  my-3">
//                     <div className="card-body">
//                       <div className="table-responsive">
//                         <table className="table table-striped table-font table-sm">
//                           <thead className="">
//                             <tr className="text-nowrap">
//                               <th>SN</th>
//                               <th>Bill Date</th>
//                               <th>Container No</th>
//                               <th>Container Size</th>
//                               <th>Container Life No</th>
//                               <th>Activity Code</th>
//                               <th>Actual Amount</th>
//                               <th>CGST Amount</th>
//                               <th>SGST Amount</th>
//                               <th>IGST Amount</th>
//                               <th>Boe No</th>
//                               <th>Boe Date</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {Data.length > 0 ? (
//                               Data.map((item, index) => (
//                                 <tr key={index}>
//                                   <td>{index + 1}</td>
//                                   <td>
//                                     {formatToDateTime(item["tns:dtBill"])}
//                                   </td>
//                                   <td>{item["tns:ctrNo"]}</td>
//                                   <td>{item["tns:ctrSize"]}</td>
//                                   <td>
//                                     {item["tns:ctrLifeNo"]
//                                       ? formatToDateTime(item["tns:ctrLifeNo"])
//                                       : ""}
//                                   </td>
//                                   <td>{item["tns:actyCd"]}</td>
//                                   <td>{item["tns:actlAmt"]}</td>
//                                   <td>{item["tns:cgstAmt"]}</td>
//                                   <td>{item["tns:sgstAmt"]}</td>
//                                   <td>{item["tns:igstAmt"]}</td>
//                                   <td>{item["tns:boeNo"]}</td>
//                                   <td>{item["tns:boeDt"]}</td>
//                                 </tr>
//                               ))
//                             ) : (
//                               <tr>
//                                 <td colSpan="11" className="text-center">
//                                   No Data Found
//                                 </td>
//                               </tr>
//                             )}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <Footer />
//               <div className="content-backdrop fade" />
//             </div>
//           </div>
//         </div>
//         <div className="layout-overlay layout-menu-toggle"></div>
//         <div className="drag-target"></div>
//       </div>
//     </>
//   );
// }

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "../main/nav";
import Footer from "../main/footer";
import DateRange from "../main/DateRange";
import axios from "axios";
import Swal from "sweetalert2";
import { formatToDateTime } from "../main/formatToDateTime";
import ImportHeader from "../main/ImportHeader";

export default function ExportRevenue() {
  const getDefaultStartDate = () => {
    let date = new Date();
    date.setDate(date.getDate() - 15); // 15 days past
    return date.toISOString().slice(0, 16);
  };

  const getDefaultEndDate = () => {
    let date = new Date();
    return date.toISOString().slice(0, 16);
  };

  const [Data, setData] = useState([]);
  const [start, setStart] = useState(getDefaultStartDate());
  const [end, setEnd] = useState(getDefaultEndDate());
  const [loading, setLoading] = useState(false);

  const GetData = async () => {
    setLoading(true);
    try {
      let url = `https://ctas.live/backend/api/get/ImportRevenue?start=${start}&end=${end}`;
      const response = await axios.get(url);
      if (response?.data?.status === "success") {
        const lat_data = response.data.data;
        let result =
          lat_data["env:Body"]["ImportReportWriteOutput"][
            "tns:ImportReportWriteOutputColl"
          ] || [];
        setData(result);
      } else {
        Swal.fire({
          icon: "warning",
          title: "Oops!",
          text: "Something Went Wrong.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Fetch Error!",
        text: error.message || "Something went wrong while fetching data.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData(); // Page load par default data fetch hoga
  }, []);

  const handleFromSubmit = (e) => {
    e.preventDefault();
    if (start && end) {
      GetData();
    }
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <ImportHeader />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row justify-content-between">
                  <div className="card my-3">
                    <div className="card-body">
                      <h4 className="text-primary">Import Revenue</h4>
                      <form className="needs-validation" noValidate onSubmit={handleFromSubmit}>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-floating form-floating-outline mb-6">
                              <input
                                type="datetime-local"
                                name="start_date"
                                className="form-control"
                                placeholder="Start Date & Time"
                                value={start}
                                onChange={(e) => setStart(e.target.value)}
                              />
                              <label className="form-label">Start Date & Time</label>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-floating form-floating-outline mb-6">
                              <input
                                type="datetime-local"
                                name="end_date"
                                className="form-control"
                                placeholder="End Date & Time"
                                value={end}
                                onChange={(e) => setEnd(e.target.value)}
                              />
                              <label className="form-label">End Date & Time</label>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <button type="submit" className="btn btn-label-primary waves-effect waves-light me-1">
                              <i className="ri-arrow-right-line ri-20px" />
                            </button>
                            <button type="button" className="btn btn-label-primary waves-effect waves-light me-1" onClick={() => window.location.reload()}>
                              <i className="ri-restart-line ri-20px" />
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div className="card my-3">
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-striped table-font table-sm">
                          <thead className="">
                            <tr className="text-nowrap">
                              <th>SN</th>
                              <th>Bill Date</th>
                              <th>Container No</th>
                              <th>Container Size</th>
                              {/* <th>Container Life No</th>
                              <th>Activity Code</th> */}
                              <th>Actual Amount</th>
                              <th>CGST Amount</th>
                              <th>SGST Amount</th>
                              <th>IGST Amount</th>
                              <th>Boe No</th>
                              <th>Boe Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Data.length > 0 ? (
                              Data.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{formatToDateTime(item["tns:dtBill"])}</td>
                                  <td>{item["tns:ctrNo"]}</td>
                                  <td>{item["tns:ctrSize"]}</td>
                                  {/* <td>{item["tns:ctrLifeNo"] ? formatToDateTime(item["tns:ctrLifeNo"]) : ""}</td>
                                  <td>{item["tns:actyCd"]}</td> */}
                                  <td>{item["tns:actlAmt"]}</td>
                                  <td>{item["tns:cgstAmt"]}</td>
                                  <td>{item["tns:sgstAmt"]}</td>
                                  <td>{item["tns:igstAmt"]}</td>
                                  <td>{item["tns:boeNo"]}</td>
                                  <td>{item["tns:boeDt"]}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="11" className="text-center">No Data Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
}
